module.exports = __webpack_public_path__ + "img/ouro.c92f6093.png";